import { render, staticRenderFns } from "./ChannelIntegrations.view.vue?vue&type=template&id=4ed6a5d6&"
import script from "./ChannelIntegrations.view.vue?vue&type=script&lang=js&"
export * from "./ChannelIntegrations.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports